import { CircularProgress } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik } from 'formik';
import {
  useCatalogByIdQuery,
  useCreateCatalog,
  useUpdateCatalog,
} from '../../api/hooks/catalogs';
import { MerchantCatalogBase } from 'src/app/api/openapi';
import CreateCatalogForm from './CreateCatalogForm';

const CreateCatalog = () => {
  const navigate = useNavigate();
  const { merchantId, catalogId } = useParams();
  const { data, isLoading } = useCatalogByIdQuery(
    { merchantId, catalogId },
    {
      enabled: !!catalogId,
    }
  );

  const { mutate: createCatalog, isLoading: isCreating } = useCreateCatalog(
    { merchantId },
    {
      onSuccess(data) {
        if (!data.id) navigate(`/merchants/${merchantId}`);
        navigate(`/merchants/${merchantId}/catalogs/${data?.id}/add-products`);
      },
    }
  );

  const { mutate: updateCatalog, isLoading: isUpdating } = useUpdateCatalog(
    { merchantId, catalogId },
    {
      onSuccess() {
        navigate('..', { relative: 'path' });
      },
    }
  );

  const handleCreateCatalog = (values: MerchantCatalogBase) => {
    if (catalogId) updateCatalog(values);
    else createCatalog(values);
  };

  if (isLoading) return <CircularProgress />;

  return (
    <Formik
      initialValues={
        {
          name: data?.name || '',
          availability_start: data?.availability_start || null,
          availability_end: data?.availability_end || null,
        } as MerchantCatalogBase
      }
      onSubmit={handleCreateCatalog}
    >
      {CreateCatalogForm}
    </Formik>
  );
};

export default CreateCatalog;
